import { render, staticRenderFns } from "./OrganizationCreateMdt.vue?vue&type=template&id=123d5b24&scoped=true"
import script from "./OrganizationCreateMdt.vue?vue&type=script&lang=js"
export * from "./OrganizationCreateMdt.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreateMdt.vue?vue&type=style&index=0&id=123d5b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d5b24",
  null
  
)

export default component.exports